"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFormField = void 0;
const tslib_1 = require("tslib");
const mergeClassName_1 = tslib_1.__importDefault(require("../utils/mergeClassName"));
const definitions_1 = require("./definitions");
const getRandomMark_1 = tslib_1.__importDefault(require("../utils/getRandomMark"));
const makeEffectStub_1 = tslib_1.__importDefault(require("../utils/makeEffectStub"));
const memoize_1 = tslib_1.__importDefault(require("../utils/memoize"));
const uniqueIdPrefix = 'df-input-' + (0, getRandomMark_1.default)() + '-';
const $component = 'theComponent';
const props = {
    /** @internal 一般不用传！很容易出幺蛾子！除非你知道你在做什么！ */
    internalStub: { type: Object, required: false },
    /** @internal 一般不用传！如果设置了，则 path 是相对于这个 parentStub 的路径。否则，默认从 root 找 */
    internalParentStub: { type: Object, required: false },
    path: { type: String, default: "" },
    ui: { type: Object, required: false },
    componentModule: { type: Object, required: false },
    readonly: { required: false },
    /** 显示在输入框旁边的标签，可传入 false 或者空字符串，就不显示标签。默认取 schema 的 title 或者 id */
    label: { type: [String, Boolean], required: false },
    className: { type: String, required: false },
    inputClassName: { type: String, required: false },
};
const data = () => {
    return {
        collapsed: false,
        inputId: uniqueIdPrefix + (0, getRandomMark_1.default)()
    };
};
const DataFormField = {
    name: "data-form-field",
    props,
    data,
    // slots: begin / middle / end
    // events: change(value, stub)
    inject: {
        [definitions_1.$formContext]: { default: null },
        [definitions_1.$chrootContext]: { default: null },
    },
    provide() {
        return {
            [definitions_1.$injectDataField]: this
        };
    },
    computed: {
        formContext() {
            return this[definitions_1.$formContext]();
        },
        chrootContext() {
            var _a;
            return (_a = this[definitions_1.$chrootContext]) === null || _a === void 0 ? void 0 : _a.call(this);
        },
        root() {
            return this.formContext.rootStub;
        },
        stub() {
            var _a;
            const presetStub = this.internalStub;
            const path = this.path;
            const parent = this.internalParentStub || ((_a = this.chrootContext) === null || _a === void 0 ? void 0 : _a.stub) || this.root;
            return presetStub || parent.getStubAtPath(path);
        },
        /**
         * 按照 $ref 修复和补全过的 DataSchema
         *
         * （注意，这里的 `schema.ui` 可能有问题，请使用 `ui` 获取 DataUIConfig 对象）
         */
        schema() {
            var _a;
            return (_a = this.stub) === null || _a === void 0 ? void 0 : _a.schema;
        },
        /**
         * DataUIConfig 对象，
         *
         * 这个是做了自动补全的，安全！
         */
        uiX() {
            const schema = this.schema;
            const propUi = this.$props.ui;
            const ctx = this.formContext;
            return schema ? Object.assign(Object.assign({}, ctx.getUIConfig(schema)), (propUi || {})) : {};
        },
        /**
         * 根据 `ui` 从组件库里拉出来的组件。
         *
         * 如果这个 DataField 有外部传入 prop componentModule，则返回外部传入的，
         * 否则根据 `ui.type` 从 `formContext` 获取
         */
        componentModuleX() {
            const componentModule = this.$props.componentModule;
            const type = this.uiX.type;
            const ctx = this.formContext;
            return componentModule || ctx.components.get(type);
        },
        /**
         * ui.settings 对象，
         *
         * 这个是做了默认值补全的
         */
        uiSettingsX() {
            var _a;
            const defaultSettings = (_a = this.componentModuleX) === null || _a === void 0 ? void 0 : _a.defaultSettings;
            const userSettings = this.uiX.settings;
            return defaultSettings && Object.assign(Object.assign({}, defaultSettings), (userSettings || {}));
        },
        readonlyX() {
            var _a, _b, _c;
            return (_a = this.$props.readonly) !== null && _a !== void 0 ? _a : (((_b = this.chrootContext) === null || _b === void 0 ? void 0 : _b.readonly) || ((_c = this.schema) === null || _c === void 0 ? void 0 : _c.readonly));
        },
        pathX() {
            var _a, _b;
            return (_b = (_a = this.stub) === null || _a === void 0 ? void 0 : _a.path) !== null && _b !== void 0 ? _b : '';
        }
    },
    methods: {
        handleChange(value) {
            var _a;
            (_a = this.stub) === null || _a === void 0 ? void 0 : _a.setValue(value);
        },
        setCollapsed(val) {
            this.collapsed = !!val;
        },
    },
    created() {
        this._updateIfChanged = (0, memoize_1.default)(() => { var _a, _b; return [((_a = this.stub) === null || _a === void 0 ? void 0 : _a.isVolatile) && Date.now(), (_b = this.stub) === null || _b === void 0 ? void 0 : _b.getValue()]; }, () => {
            this.$forceUpdate();
            this.$nextTick(() => {
                var _a;
                (_a = this.$refs[$component]) === null || _a === void 0 ? void 0 : _a.$forceUpdate();
            });
        });
        this._bindRootStub = (0, makeEffectStub_1.default)((root) => {
            if (!root)
                return;
            const path = this.pathX;
            const listener = (newVal, oldVal, trace) => {
                this._updateIfChanged();
                trace.some((t, index) => {
                    if (t.path === path) {
                        this.$emit('change', t.value, this.stub, trace.slice(0, index + 1));
                        this.$emit('update:value', t.value);
                    }
                });
            };
            root.on('change', listener);
            this._updateIfChanged();
            return () => { root.off('change', listener); };
        });
    },
    mounted() {
        this._bindRootStub(this.root);
        if (this.uiX.collapsed)
            this.collapsed = true;
    },
    updated() {
        this._bindRootStub(this.root);
    },
    destroyed() {
        this._bindRootStub(null);
    },
    render(h) {
        var _a, _b, _c;
        const props = this.$props;
        const { formContext, stub, schema, uiX: ui, uiSettingsX: uiSettings, componentModuleX: componentModule } = this;
        if (!stub)
            return h();
        if (!schema)
            return h();
        if (!componentModule)
            return h();
        const readonly = this.readonlyX;
        const label = (_b = (_a = props.label) !== null && _a !== void 0 ? _a : schema.title) !== null && _b !== void 0 ? _b : schema.id;
        const collapsible = (_c = ui.collapsible) !== null && _c !== void 0 ? _c : componentModule.collapsible;
        const className = (0, mergeClassName_1.default)("ds-dataField", schema.required && "is-required", props.className);
        return h('div', {
            class: className,
            attrs: Object.assign({ 'data-path': this.pathX, 'data-type': schema.type }, collapsible ? { 'data-collapsible': true, 'data-collapsed': this.collapsed } : {})
        }, [
            this.$slots.begin,
            label && (componentModule.hideLabel
                ? h('span', { staticClass: "ds-dataField-label-placeholder" })
                : h(formContext.FieldLabel, {
                    props: {
                        htmlFor: this.inputId,
                        text: label,
                        schema: schema,
                        collapsible: collapsible,
                        collapsed: this.collapsed,
                        // setCollapsed
                    },
                    on: {
                        'update:collapsed': this.setCollapsed
                    }
                })),
            this.$slots.middle,
            h('div', { staticClass: "ds-dataField-input" }, [
                h(componentModule.component, {
                    ref: $component,
                    attrs: Object.assign({ schema,
                        ui,
                        uiSettings,
                        readonly, value: stub.getValue(), 
                        // onChange
                        // container is always injected from $injectDataField
                        inputId: this.inputId, className: props.inputClassName, labelText: label || '', collapsed: this.collapsed }, ui.props),
                    style: ui.style,
                    on: {
                        'change': this.handleChange,
                    }
                })
            ]),
            this.$slots.end,
        ]);
    }
};
exports.DataFormField = DataFormField;
exports.default = DataFormField;
//# sourceMappingURL=DataFormField.js.map